import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  GetSalaryStructuresForUsersGraphQLRequest,
  GetSalaryStructuresForUsersGraphResponse,
} from '../types';

export const getSalaryStructuresForUsersQuery = gql`
  query PayrollGetSalaryStructuresForUsers($input: PayrollGetSalaryStructuresForUsersInput!) {
    payrollGetSalaryStructuresForUsers(input: $input) {
      data {
        salaryStructureUsers {
          salaryStructure {
            id
            name
            description
            status
            type
            employeeCount
          }
        }
      }
      code
      success
      message
    }
  }
`;

export const getSalaryStructuresForUsers = (
  queryVariables: GetSalaryStructuresForUsersGraphQLRequest,
) => {
  return graphQLApi<
    GetSalaryStructuresForUsersGraphResponse,
    GetSalaryStructuresForUsersGraphQLRequest
  >({
    query: getSalaryStructuresForUsersQuery,
    queryVariables,
  });
};

export default getSalaryStructuresForUsers;
